import { render } from "./FacebookChat.vue?vue&type=template&id=70f759c4&scoped=true&lang=pug"
import script from "./FacebookChat.vue?vue&type=script&lang=js"
export * from "./FacebookChat.vue?vue&type=script&lang=js"

import "./FacebookChat.vue?vue&type=style&index=0&id=70f759c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f759c4"]])

export default __exports__